import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export default function SkuflixChromecastIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M2.84766 7.56054V5.28027C2.84766 4.67551 3.0879 4.09551 3.51553 3.66788C3.94317 3.24024 4.52316 3 5.12793 3L18.9714 3C19.5762 3 20.1562 3.24024 20.5838 3.66788C21.0114 4.09551 21.2517 4.67551 21.2517 5.28027V18.9619C21.2517 19.5667 21.0114 20.1467 20.5838 20.5743C20.1562 21.0019 19.5762 21.2422 18.9714 21.2422H16.5293"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M2.84766 12.1172C5.18194 12.3649 7.36073 13.4055 9.02059 15.0653C10.6805 16.7252 11.721 18.904 11.9687 21.2383"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M2.84766 16.6875C3.97942 16.8983 5.02084 17.4468 5.83488 18.2608C6.64891 19.0749 7.19741 20.1163 7.4082 21.248"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M2.84766 21.2422H2.85766"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
}
